import type { DiscountCode } from './api';

export type DiscountCodeStatus = 'live' | 'scheduled' | 'expired' | 'exhausted' | 'off';

/**
 * The at-a-glance state an administrator scans a discount list for. Priority: an
 * inactive code always reads "off", regardless of window or redemptions — deactivation
 * is meant to be unambiguous. Otherwise the validity window and the redemption cap are
 * checked against `now`.
 */
export function discountCodeStatus(
  discountCode: DiscountCode,
  now: Date = new Date(),
): DiscountCodeStatus {
  if (!discountCode.active) return 'off';

  if (discountCode.startsAt && new Date(discountCode.startsAt) > now) return 'scheduled';
  if (discountCode.endsAt && new Date(discountCode.endsAt) <= now) return 'expired';

  if (
    discountCode.redemptionCap != null &&
    discountCode.redeemedUnits >= discountCode.redemptionCap
  ) {
    return 'exhausted';
  }

  return 'live';
}
